import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=24ff407e&scoped=true&"
import script from "./BillingSummary.vue?vue&type=script&lang=js&"
export * from "./BillingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BillingSummary.vue?vue&type=style&index=0&id=24ff407e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff407e",
  null
  
)

export default component.exports